<template>
  <header>
    <nav class="navbar navbar-expand-md">
      <router-link :to="{ name: 'dashboard' }" class="navbar-brand">
        <img src="@/assets/images/logo.png" alt class="logo-header" />
      </router-link>

      <slot name="mobile"></slot>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav mr-auto"></ul>
        <a
          class="btn btn-nav home"
          v-tooltip.bottom-start="$t('Full Screen')"
          @click.prevent="fn_toggleFullscreen"
        >
          <icon icon="maximize" />
        </a>
        <a
          class="btn btn-nav home"
          v-tooltip.bottom-start="$t('Dashboard')"
          @click.prevent="$router.push({ name: 'dashboard' })"
        >
          <v-icon>mdi-view-dashboard-outline</v-icon>
        </a>
        <a
          class="btn btn-nav home"
          v-tooltip.bottom-start="$t('Walk In Order')"
          @click.prevent="orderTable()"
        >
          <v-icon>mdi-table-furniture</v-icon>
        </a>

        <a
          href
          class="btn btn-nav"
          v-tooltip.bottom-start="$t('Order Type')"
          @click.prevent="$router.push({ name: 'select_type' })"
        >
          <v-icon>mdi-room-service-outline</v-icon>
        </a>

        <a
          class="btn btn-nav"
          v-tooltip.bottom-start="$t('Order List')"
          @click.prevent="fn_Goto('order_list')"
        >
          <v-icon>mdi-format-list-checks</v-icon>
          <span v-if="count_sale > 0" class="badge badge-pill badge-danger">{{
            count_sale
          }}</span>
        </a>
        <slot></slot>
      </div>
    </nav>
  </header>
</template>
<script>
  import "../assets/scss/main.scss";
  import store from "vuex";
  import { mapGetters } from "vuex";
  import Swal from "sweetalert2";
  export default {
    name: "CashierHeader",
    layout: "cashier",
    middleware: "auth",
    data() {
      return {
        logo: require("../assets/images/logo.png"),
        popup_size: "",
        question_img: require("../assets/images/question_icon.svg"),
        isFullscreen: false,
      };
    },
    computed: mapGetters({
      itemTableOrder: "nav/itemTableOrder",
      products_Order: "nav/productionsOrder",
      getUser: "auth/user",
      nav_lang: "nav/navLang",
      nav_switch_slider: "nav/switchSlider",
      order_items: "order/order_items",
      count_sale: "order/count_sale",
    }),
    mounted() {},
    methods: {
      async orderTable() {
        if (this.$route.name !== "order") {
          await this.$store.dispatch("order/clear_order");
          await this.$store.dispatch("order/modifyOrder", {});
          await this.$store.dispatch("order/setOrderType", "walk_in");
          await this.$router
            .push({ name: "order", query: { table: true } })
            .catch((err) => {});
        }
      },
      showMenu() {
        this.$store.dispatch("nav/collapse_lang_active", this.nav_lang);
      },
      hideSwicthSlider() {
        this.$store.dispatch("nav/collapse_nav_switch_slider", false);
      },
      setCollapeItemOrder() {
        this.$store.dispatch("nav/collape_item_order", this.itemTableOrder);
        this.$store.dispatch("nav/collape_products_order", this.products_Order);
      },
      fn_Goto(page) {
        this.$router.push({ name: "order_list" }).catch((err) => {});
      },
      fn_toggleFullscreen: function(event) {
        var elem = document.documentElement;
        if (
          document.fullscreenEnabled ||
          document.webkitFullscreenEnabled ||
          document.mozFullScreenEnabled ||
          document.msFullscreenEnabled
        ) {
          if (!this.isFullscreen) {
            if (elem.requestFullscreen) {
              elem.requestFullscreen();
              this.isFullscreen = true;
              return;
            } else if (elem.webkitRequestFullscreen) {
              elem.webkitRequestFullscreen();
              this.isFullscreen = true;
              return;
            } else if (elem.mozRequestFullScreen) {
              elem.mozRequestFullScreen();
              this.isFullscreen = true;
              return;
            } else if (elem.msRequestFullscreen) {
              elem.msRequestFullscreen();
              this.isFullscreen = true;
              return;
            }
          } else {
            if (document.exitFullscreen) {
              document.exitFullscreen();
              this.isFullscreen = false;
              return;
            } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
              this.isFullscreen = false;
              return;
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
              this.isFullscreen = false;
              return;
            } else if (document.msExitFullscreen) {
              document.msExitFullscreen();
              this.isFullscreen = false;
              return;
            }
          }
        }
      },
    },
  };
</script>
<style lang="css" scoped>
  .btn-nav {
    margin-right: 15px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    border-radius: 7px;
  }
  .btn-nav:hover {
    background: #d6ddab7a;
  }
</style>
